import Swal from '../theme/swal';
import KI from '../theme/palette';

// Carte « Produit déjà au catalogue » partagée (brand kit) — utilisée partout
// où le backend refuse un nom de produit en doublon (ACommander, réception BC,
// facturation, fiche produit). Une seule source pour le texte et le style.

// Nom normalisé : casse, accents et espaces multiples ignorés
// (« Crème  Solaire » ≡ « creme solaire »).
export const normProductName = (s) => String(s || '')
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/\s+/g, ' ')
  .trim();

const escHtml = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => (
  { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
));

// Message d'erreur exploitable depuis une réponse DRF ({champ: [msg]}) ou une
// Error classique.
export const extractApiErrorMessage = (e) => {
  let message = e && e.message;
  if (!message && e && typeof e === 'object') {
    const first = Object.values(e)[0];
    message = Array.isArray(first) ? first[0] : first;
  }
  return message;
};

// Erreur DRF « Un produit avec ce nom existe déjà. » (products/api_views.py).
export const isDuplicateProductNameError = (message) => (
  /produit avec ce nom existe d/i.test(String(message || ''))
);

// Couleur primaire du brand kit au runtime (panneau Apparence).
export const brandPrimaryColor = () => (
  getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim() || KI.coralDark
);

// Affiche la carte. `product` (fiche existante) est optionnel : sans fiche
// retrouvée on montre le nom saisi seul. `confirmText` absent → un seul bouton
// « Modifier le nom ». Retourne la promesse Swal (r.isConfirmed = action).
export const duplicateProductAlert = ({ product, name, confirmText }) => {
  const dispName = (product && product.name) || name || '';
  const codePart = product && product.code ? ` (code ${escHtml(product.code)})` : '';
  const stockPart = product ? ` — stock actuel : <b>${product.stock ?? 0}</b>` : '';
  return Swal.fire({
    title: 'Produit déjà au catalogue',
    html: `<div style="text-align:left">
      <p style="margin:0 0 8px">« <b>${escHtml(dispName)}</b> » existe déjà${codePart}${stockPart}.</p>
      <p style="margin:0;color:${KI.faint};font-size:0.9em">S'il s'agit du même produit, utilisez sa fiche. Sinon, modifiez le nom pour les distinguer.</p>
    </div>`,
    icon: 'warning',
    showCancelButton: Boolean(confirmText),
    confirmButtonText: confirmText || 'Modifier le nom',
    cancelButtonText: 'Modifier le nom',
    confirmButtonColor: brandPrimaryColor(),
  });
};
